import React from "react";

// Local Stylesheet
import "./Header.scss";

function Header({
  setIsRequestMutationPopupOpen,
  selectedRows = [],
  openCancelRequestPopup = () => {},
}) {
  return (
    <div className="request-header-container-wrapper">
      <div className="request-header-container h-100">
        <div className="request-header-title">Requests</div>
        <div className="d-flex">
          {selectedRows?.length > 0 && (
            <button
              type="button"
              className="secondary-button"
              data-dismiss="modal"
              style={{ minWidth: "200px" }}
              onClick={openCancelRequestPopup}
            >
              Cancel Selected <em>{`(${selectedRows?.length})`}</em>
            </button>
          )}

          <button
            className="primary-button ml-5"
            onClick={() => setIsRequestMutationPopupOpen(true)}
          >
            Create Request
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
